// Intake Form Builder — staff CRUD + client portal fill.
import { API } from './_client';
import axios from 'axios';

// Public portal endpoints don't need auth
const publicClient = axios.create({
  baseURL: API.defaults.baseURL,
  headers: { 'Content-Type': 'application/json' },
});

export const intake = {
  // Staff
  listTemplates: (opts = {}) => API.get('/intake/templates', { params: opts }).then((r) => r.data),
  getTemplate: (id) => API.get(`/intake/templates/${id}`).then((r) => r.data),
  createTemplate: (payload) => API.post('/intake/templates', payload).then((r) => r.data),
  updateTemplate: (id, patch) => API.patch(`/intake/templates/${id}`, patch).then((r) => r.data),
  deleteTemplate: (id) => API.delete(`/intake/templates/${id}`).then((r) => r.data),
  invite: (payload) => API.post('/intake/invite', payload).then((r) => r.data),
  listSubmissions: (opts = {}) => API.get('/intake/submissions', { params: opts }).then((r) => r.data),
  getSubmission: (id) => API.get(`/intake/submissions/${id}`).then((r) => r.data),
  applySubmission: (id, payload) => API.post(`/intake/submissions/${id}/apply`, payload).then((r) => r.data),
  listSubmissionDocs: (id) => API.get(`/intake/submissions/${id}/docs`).then((r) => r.data),
  downloadDoc: (docId) => API.get(`/intake/docs/${docId}/download`, { responseType: 'blob' }).then((r) => r.data),
  // Public
  portalLoad: (token) => publicClient.get(`/intake/portal/${token}`).then((r) => r.data),
  portalSave: (token, answers) => publicClient.post(`/intake/portal/${token}/save`, { answers }).then((r) => r.data),
  portalSubmit: (token, answers) => publicClient.post(`/intake/portal/${token}/submit`, { answers }).then((r) => r.data),
};
